
import { AssetsUserDetailsTypeInfoBase } from './assets-user-details.typeinfo.base';


export class AssetsUserDetailsTypeInfo extends AssetsUserDetailsTypeInfoBase {
}

export const ASSETS_USER_DETAILS_TYPE: AssetsUserDetailsTypeInfo = new AssetsUserDetailsTypeInfo();



